import LocalizationService from "../../../../services/localizationService";
import { interfaces } from "inversify";
import LegalPerson from "../../../../models/legalPerson";
import PersonViewModel from "../personViewModel";

export default class LegalPersonViewModel extends PersonViewModel {
  constructor(public person: LegalPerson, protected localizationService: LocalizationService) {
    super(person, localizationService);
  }

  static Factory({ container }: interfaces.Context) {
    return (legalPerson: LegalPerson) => new LegalPersonViewModel(legalPerson, container.get(LocalizationService));
  }
}
